export const translations = {
  home: {
    hero: {
      badge: {
        fr: "L'Écosystème Intégré de Vie Moderne en Afrique",
        en: "The Integrated Modern Life Ecosystem in Africa"
      },
      title: {
        fr: "EKIP - Ensemble,",
        en: "EKIP - Together,"
      },
      titleHighlight: {
        fr: "Vivons Mieux",
        en: "Living Better"
      },
      description: {
        fr: "Nous créons le premier écosystème de vie intégré en Côte d'Ivoire et en Afrique de l'Ouest, fusionnant l'habitat, l'énergie et la technologie dans une expérience client fluide et cohérente.",
        en: "We are creating the first integrated life ecosystem in Côte d'Ivoire and West Africa, merging housing, energy, and technology into a seamless and consistent customer experience."
      },
      btn1: {
        fr: "Découvrir Notre Vision",
        en: "Discover Our Vision"
      },
      btn2: {
        fr: "Nos Filiales",
        en: "Our Subsidiaries"
      }
    },
    vision: {
      title: {
        fr: "Notre Vision : Bâtir l'Écosystème de Demain",
        en: "Our Vision: Building Tomorrow's Ecosystem"
      },
      description: {
        fr: "EKIP ambitionne de transformer la manière dont les Ivoiriens vivent, se déplacent et consomment. Nous développons un écosystème où chaque besoin quotidien trouve sa solution dans un réseau interconnecté et intelligent.",
        en: "EKIP aims to transform how Ivorians live, move, and consume. We are developing an ecosystem where every daily need finds its solution in an interconnected and intelligent network."
      },
      ambitionTitle: {
        fr: "Notre ambition",
        en: "Our ambition"
      },
      ambitionText: {
        fr: "Être le premier groupe en Afrique de l'Ouest à intégrer parfaitement l'immobilier résidentiel, la distribution énergétique et les solutions technologiques pour créer une véritable expérience de vie moderne et durable.",
        en: "To be the first group in West Africa to perfectly integrate residential real estate, energy distribution, and technological solutions to create a truly modern and sustainable living experience."
      }
    },
    stats: {
      title: {
        fr: "En Un Coup d'Œil",
        en: "At a Glance"
      },
      items: [
        { value: "4", label: { fr: "Filiales opérationnelles", en: "Operating Subsidiaries" } },
        { value: "179+", label: { fr: "Hectares en développement", en: "Hectares under development" } },
        { value: "120M USD", label: { fr: "Projets d'infrastructure", en: "Infrastructure Projects" } },
        { value: "500+", label: { fr: "Emplois directs d'ici 2030", en: "Direct jobs by 2030" } }
      ]
    },
    subsidiaries: {
      title: {
        fr: "Nos 4 Piliers",
        en: "Our 4 Pillars"
      },
      subtitle: {
        fr: "Un écosystème intégré au service de votre quotidien",
        en: "An integrated ecosystem serving your daily life"
      },
      items: [
        {
          name: "KIP ENERGY",
          tagline: { fr: "L'Énergie qui Propulse", en: "The Energy that Drives" },
          description: { fr: "Distribution exclusive Wayne • Infrastructures pétrolières • Trading", en: "Exclusive Wayne Distribution • Oil Infrastructure • Trading" }
        },
        {
          name: "KIPYZ DESIGN & HOUSES",
          tagline: { fr: "L'Habitat Moderne", en: "Modern Living" },
          description: { fr: "Cités résidentielles • Co-création • Espaces de vie intégrés", en: "Residential cities • Co-creation • Integrated living spaces" }
        },
        {
          name: "EKIPTECH",
          tagline: { fr: "L'Intelligence qui Connecte", en: "The Intelligence that Connects" },
          description: { fr: "Solutions domotiques • IoT • Distribution Zebra Technologies", en: "Smart home solutions • IoT • Zebra Technologies Distribution" }
        },
        {
          name: "KIPAY",
          tagline: { fr: "La Fluidité au Quotidien", en: "Daily Fluidity" },
          description: { fr: "Solutions de paiement • Programme de fidélité • Wallet digital", en: "Payment solutions • Loyalty program • Digital wallet" }
        }
      ],
      learnMore: { fr: "En savoir plus", en: "Learn more" }
    },
    cta: {
      title: {
        fr: "Prêt à Rejoindre l'Écosystème EKIP ?",
        en: "Ready to Join the EKIP Ecosystem?"
      },
      description: {
        fr: "Découvrez comment nous transformons la vie quotidienne en Côte d'Ivoire",
        en: "Discover how we are transforming daily life in Côte d'Ivoire"
      },
      btn1: {
        fr: "Contactez-nous",
        en: "Contact us"
      },
      btn2: {
        fr: "Découvrir nos synergies",
        en: "Discover our synergies"
      }
    }
  },
  about: {
    hero: {
      title: { fr: "EKIP Holding Company", en: "EKIP Holding Company" },
      subtitle: { fr: "Pilotage Stratégique & Développement des Synergies", en: "Strategic Management & Synergy Development" },
      description: { fr: "Un groupe ivoirien multi-sectoriel créé pour développer le premier écosystème de vie intégré en Côte d'Ivoire et en Afrique de l'Ouest.", en: "An Ivorian multi-sector group created to develop the first integrated life ecosystem in Côte d'Ivoire and West Africa." }
    },
    presentation: {
      title: { fr: "Qui Sommes-Nous ?", en: "Who Are We?" },
      text1: { fr: "EKIP Holding Company est un groupe ivoirien multi-sectoriel créé pour développer le premier écosystème de vie intégré en Côte d'Ivoire et en Afrique de l'Ouest. Notre approche unique repose sur la création de synergies puissantes entre nos quatre filiales opérationnelles.", en: "EKIP Holding Company is an Ivorian multi-sector group created to develop the first integrated life ecosystem in Côte d'Ivoire and West Africa. Our unique approach is based on creating powerful synergies between our four operating subsidiaries." },
      text2: { fr: "En connectant l'habitat, l'énergie, la technologie et les solutions de paiement, nous offrons à nos clients une expérience de vie moderne, fluide et cohérente.", en: "By connecting housing, energy, technology, and payment solutions, we offer our customers a modern, seamless, and consistent living experience." },
      missionTitle: { fr: "Notre Mission", en: "Our Mission" },
      missionText: { fr: "Développer des solutions innovantes et durables qui transforment la manière dont les Ivoiriens vivent, se déplacent et consomment, en créant des synergies entre l'immobilier résidentiel, la distribution énergétique et les technologies connectées.", en: "To develop innovative and sustainable solutions that transform how Ivorians live, move, and consume, by creating synergies between residential real estate, energy distribution, and connected technologies." }
    },
    values: {
      title: { fr: "Nos Valeurs", en: "Our Values" },
      subtitle: { fr: "Les principes qui guident nos actions et nos décisions", en: "The principles that guide our actions and decisions" },
      items: [
        { title: { fr: "Innovation", en: "Innovation" }, description: { fr: "Repousser les limites du possible pour créer des solutions adaptées aux besoins africains.", en: "Pushing the boundaries of what's possible to create solutions tailored to African needs." } },
        { title: { fr: "Intégration", en: "Integration" }, description: { fr: "Développer des synergies intelligentes entre nos activités pour maximiser la valeur client.", en: "Developing smart synergies between our activities to maximize customer value." } },
        { title: { fr: "Excellence", en: "Excellence" }, description: { fr: "Viser les plus hauts standards de qualité dans chaque réalisation.", en: "Aiming for the highest quality standards in every achievement." } },
        { title: { fr: "Durabilité", en: "Sustainability" }, description: { fr: "Construire pour les générations futures avec une conscience environnementale forte.", en: "Building for future generations with strong environmental awareness." } },
        { title: { fr: "Impact", en: "Impact" }, description: { fr: "Contribuer au développement socio-économique de la Côte d'Ivoire.", en: "Contributing to the socio-economic development of Côte d'Ivoire." } }
      ]
    },
    governance: {
      title: { fr: "Structure de Pilotage", en: "Management Structure" },
      subtitle: { fr: "EKIP Holding Company assure la coordination et le développement de l'ensemble du groupe", en: "EKIP Holding Company ensures the coordination and development of the entire group" },
      items: [
        { title: { fr: "Pilotage stratégique", en: "Strategic management" }, description: { fr: "Définition et mise en œuvre de la stratégie globale du groupe", en: "Definition and implementation of the group's overall strategy" } },
        { title: { fr: "Allocation du capital", en: "Capital allocation" }, description: { fr: "Optimisation des investissements entre les filiales", en: "Optimization of investments between subsidiaries" } },
        { title: { fr: "Gouvernance & contrôle", en: "Governance & control" }, description: { fr: "Supervision et évaluation des performances", en: "Supervision and performance evaluation" } },
        { title: { fr: "Synergies inter-filiales", en: "Inter-subsidiary synergies" }, description: { fr: "Création de valeur par l'intégration des activités", en: "Value creation through activity integration" } }
      ]
    },
    cta: {
      title: { fr: "Ensemble, Construisons l'Avenir", en: "Together, Let's Build the Future" },
      description: { fr: "Rejoignez-nous dans notre mission de transformation de la vie quotidienne en Afrique de l'Ouest", en: "Join us in our mission to transform daily life in West Africa" }
    }
  },
  contact: {
    hero: {
      title: { fr: "Contactez-Nous", en: "Contact Us" },
      subtitle: { fr: "Nous sommes à votre écoute pour répondre à toutes vos questions", en: "We are here to answer all your questions" }
    },
    headquarters: { fr: "Siège Social", en: "Headquarters" },
    address: { fr: "Adresse", en: "Address" },
    phone: { fr: "Téléphone", en: "Phone" },
    email: { fr: "Email", en: "Email" },
    hours: { fr: "Horaires", en: "Hours" },
    form: {
      title: { fr: "Envoyez-nous un Message", en: "Send us a Message" },
      firstName: { fr: "Prénom", en: "First Name" },
      lastName: { fr: "Nom", en: "Last Name" },
      company: { fr: "Entreprise", en: "Company" },
      subject: { fr: "Sujet", en: "Subject" },
      message: { fr: "Message", en: "Message" },
      messagePlaceholder: { fr: "Votre message...", en: "Your message..." },
      send: { fr: "Envoyer", en: "Send" },
      subjects: [
        { fr: "Information générale", en: "General information" },
        { fr: "Partenariat", en: "Partnership" },
        { fr: "Investissement", en: "Investment" },
        { fr: "Carrière", en: "Career" },
        { fr: "Presse", en: "Press" },
        { fr: "Autre", en: "Other" }
      ]
    },
    subsidiariesContact: { fr: "Contacts par Filiale", en: "Contacts by Subsidiary" },
    opportunities: {
      title: { fr: "Opportunités", en: "Opportunities" },
      careers: { fr: "Carrières", en: "Careers" },
      careersDesc: { fr: "Rejoignez un groupe en forte croissance", en: "Join a fast-growing group" },
      careersBtn: { fr: "Voir nos offres d'emploi", en: "View our job offers" },
      partnerships: { fr: "Partenariats", en: "Partnerships" },
      partnershipsDesc: { fr: "Collaborons pour créer de la valeur", en: "Let's collaborate to create value" },
      partnershipsBtn: { fr: "Contactez notre équipe", en: "Contact our team" },
      press: { fr: "Presse", en: "Press" },
      pressDesc: { fr: "Accédez à nos ressources média", en: "Access our media resources" },
      pressBtn: { fr: "Espace Presse", en: "Press Room" }
    }
  },
  news: {
    hero: {
      title: { fr: "Actualités", en: "News" },
      subtitle: { fr: "Suivez les dernières nouvelles et réalisations du groupe EKIP Holding", en: "Follow the latest news and achievements of EKIP Holding group" }
    },
    pressRelease: { fr: "Communiqué de Presse", en: "Press Release" },
    pressArticles: { fr: "Articles de Presse", en: "Press Articles" },
    onlineArticles: { fr: "Articles en Ligne", en: "Online Articles" }
  },
  footer: {
    ekipHolding: {
      fr: "EKIP Holding",
      en: "EKIP Holding"
    },
    subsidiaries: {
      fr: "Nos Filiales",
      en: "Our Subsidiaries"
    },
    projects: {
      fr: "Nos Projets",
      en: "Our Projects"
    },
    contact: {
      fr: "Contact",
      en: "Contact"
    },
    copyright: {
      fr: "© 2024 EKIP Holding Company. Tous droits réservés.",
      en: "© 2024 EKIP Holding Company. All rights reserved."
    }
  }
};
